import React from 'react'

import Backend from '../../../../../utils/Backend'
import handleTimeout from '../../../../../helper/timeout_handler'
import { vehicleTypes } from '../../../../../helper/constants'
import useFinance from '../../../../../components/Hooks/isFinance'

import VehicleOptions from '../../../../../components/VehicleOptions'


// baseVehicle get here from the special requests far below (NEXT.JS APPROACH)
export default function FinanceOptionsPage({ baseVehicle }: any) {
  useFinance(baseVehicle)

  return (
    <VehicleOptions baseVehicle={baseVehicle} financePage 
      commercial={baseVehicle?.vehicle_type === vehicleTypes.commercial}
    />
  );
};

export async function getServerSideProps({ res, params: { id } } : any) {
  // params contains the vehicle `id`
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )

  const response = await handleTimeout(Backend.getVehicleByID(id), `Vehicle ${id}`)

  if (!response) {
    throw new Error("Failed to fetch Vehicle")
  }

  const baseVehicle = response.data.content

  // Pass data to the page via props
  return { 
    props: { baseVehicle }
  }
}
